<template>
  <a-layout>
    <a-space style="margin-top: 2px">
      <a-input-search v-model="query['order.no']" :placeholder="$t('placeholder.orderNo')" allowClear class="query" @pressEnter="fetch" @search="fetch"/>
      <a-input-search v-model="query['commandId']" :placeholder="$t('placeholder.commandId')" allowClear class="query" @pressEnter="fetch" @search="fetch"/>
      <a-select v-model="query['commandStatus']" :placeholder="$t('placeholder.commandStatus')" allowClear class="query" @change="fetch">
        <a-select-option v-for="d in commandStatus" :key="d.ordinal">{{d.name}}</a-select-option>
      </a-select>
      <a-date-picker v-model="query.commandDateFilter.start" :disabled-date="disabledStartDate" :placeholder="$t('placeholder.startTime')" allowClear class="query" show-today valueFormat="YYYY-MM-DD"/>
      <a-date-picker v-model="query.commandDateFilter.end" :disabled-date="disabledEndDate" :placeholder="$t('placeholder.endTime')" allowClear class="query" show-today valueFormat="YYYY-MM-DD"/>
      <vxe-button content="button.query" icon="vxe-icon-search" size="mini" status="primary" @click="fetch"/>
      <vxe-button content="button.reset" icon="vxe-icon-undo" size="mini" status="danger" @click="reset"/>
      <vxe-button content="button.expConfirm" size="mini" status="info" @click="exp"/>
    </a-space>
    <a-space style="margin-top: 2px">
      <a-input-search v-model="query['item.no']" :placeholder="$t('placeholder.itemNo')" allowClear class="query" @pressEnter="fetch" @search="fetch"/>
      <a-input-search v-model="query['item.name']" :placeholder="$t('placeholder.itemName')" allowClear class="query" @pressEnter="fetch" @search="fetch"/>
      <a-input-search v-model="query['item.mnemonicCode']" :placeholder="$t('placeholder.mnemonicCode')" allowClear class="query" @pressEnter="fetch" @search="fetch"/>
      <a-input-search v-model="query['lot.no']" :placeholder="$t('placeholder.lotNo')" allowClear class="query" @pressEnter="fetch" @search="fetch"/>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      :export-config="{}"
      :keyboard-config="{isArrow: true}"
      :column-config="{resizable: true}"
      :row-config="{isCurrent: true, isHover: true}"
      align="center"
      ref="table"
      :data="data"
      :loading="loading"
      :height="scrollY"
      :scroll-x="{enabled: true}"
      size="mini"
      style="margin-top: 2px">
      <vxe-column fixed="left" title="business.label.indexNo" type="seq" width="50"/>
      <vxe-column field="command.id" title="business.label.commandId" width="120"/>
      <vxe-column field="command.addTime" sortable title="business.label.addTime" width="170"/>
      <vxe-column field="inspectTime" sortable title="business.label.inspectTime" width="170"/>
      <vxe-column field="command.commandStatus" sortable title="business.label.dataSource" width="120">
        <span slot-scope="{ row }">{{commandStatus.find(item => item.ordinal === row.command.commandStatus).name}}</span>
      </vxe-column>
      <vxe-column field="order.no" sortable title="business.label.orderNo" width="120"/>
      <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
      <vxe-column field="item.name" title="business.label.itemName" width="120"/>
      <vxe-column field="pack.specification" title="business.label.specification" width="120"/>
      <vxe-column field="pack.factor" title="business.label.factor" width="60"/>
      <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
      <vxe-column field="command.packType" sortable title="business.label.packType" width="120">
        <span slot-scope="{ row }">{{packTypes.find(item => item.ordinal === row.command.packType).name}}</span>
      </vxe-column>
      <vxe-column field="lot.approvalNo" title="business.label.approvalNo" width="150"/>
      <vxe-column field="lot.manufacturer" title="business.label.manufacturer" width="120"/>
      <vxe-column field="lot.no" sortable title="business.label.lotNo" width="120"/>
      <vxe-column field="lot.productionDate" title="business.label.productionDate" width="100"/>
      <vxe-column field="lot.validUntil" title="business.label.validUntil" width="100"/>
      <vxe-column field="container.no" sortable title="business.label.containerNo" width="90"/>
      <vxe-column field="command.allocateQuantity" title="business.label.allocateQuantity" width="120"/>
      <vxe-column field="allocateLocation.no" title="business.label.allocateLocation" width="120"/>
      <vxe-column field="putawayLocation.no" title="business.label.putawayLocation" width="120"/>
      <vxe-column field="storageRoom.name" title="business.label.storageRoom" width="120"/>
      <vxe-column field="command.putawayQuantity" title="business.label.putawayQuantity" width="120"/>
      <vxe-column field="asnOrder.operator" title="business.label.operator" width="120"/>
      <vxe-column field="receivingman" title="business.label.receivingman" width="120"/>
      <vxe-column field="inspector" title="business.label.inspector" width="120"/>
      <vxe-column field="putaway.shelver" title="business.label.shelver" width="120"/>
      <vxe-column field="putaway.shelvingTime" sortable title="business.label.shelvingTime" width="170"/>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="refundable" title="business.label.refundable" width="70"/>
    </vxe-table>
    <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
  </a-layout>
</template>
<script>
import { findAll, findEnum } from '@/api/Api'
import moment from 'moment'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
  name: 'ContainerCommandQuery',
  data() {
    return {
      data: [],
      commandStatus: [],
      packTypes: [],
      loading: false,
      size: 10,
      page: 1,
      contentSize: 0,
      query: {
        'order.no': '',
        commandId: '',
        commandStatus: undefined,
        commandDateFilter: {
          start: moment().format('YYYY-MM-DD'),
          end: moment().format('YYYY-MM-DD')
        },
        'item.no': '',
        'item.name': '',
        'item.mnemonicCode': '',
        'lot.no': ''
      },
      scrollY: Vue.ls.get(SCREEN_HEIGHT) - 300
    }
  },
  mounted() {
    findEnum('CommandStatus').then(res => {
      if (res.success) {
        this.commandStatus = res.result
      }
    })
    findEnum('PackType').then(res => {
      if (res.success) {
        this.packTypes = res.result
      }
    })
  },
  methods: {
    moment,
    disabledStartDate(startValue) {
      const endValue = this.query.commandDateFilter.end
      if (!startValue || !endValue) {
        return false
      }
      return new Date(startValue) > new Date(endValue)
    },
    disabledEndDate(endValue) {
      const startValue = this.query.commandDateFilter.start
      if (!endValue || !startValue) {
        return false
      }
      return new Date(startValue) >= new Date(endValue)
    },
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      const args = Object.assign({}, this.query)
      if (args.commandDateFilter.start === null && args.commandDateFilter.end === null) {
        args.commandDateFilter = null
      }
      findAll('containerCommandFactory', args, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
        }
      }).finally(() => this.loading = false)
    },
    exp() {
      this.$refs.table.openExport()
    },
    reset() {
      this.query = {
        'order.no': '',
        commandId: '',
        commandStatus: undefined,
        commandDateFilter: {
          start: moment().format('YYYY-MM-DD'),
          end: moment().format('YYYY-MM-DD')
        },
        'item.no': '',
        'item.name': '',
        'item.mnemonicCode': '',
        'lot.no': ''
      }
      this.fetch()
    }
  }
}
</script>
<style scoped>
.query {
  width: 200px;
}
</style>